<template>
    <div class="text-center">
        <div class="pt-5 pb-5 header">
            <h1>Não conseguimos encontrar a página que você acessou</h1>
            <h2>Mas encontramos isso...</h2>

            <div class="animation-box">
                <img src="/img/peter-surprise.gif" alt="" />
            </div>
        </div>

        <div class="message">
            <p class="mb-3">A página que você acessou não existe ou está em manutenção.</p>
            <p><router-link :to="{ name: 'home' }">Volte para a Página Inicial</router-link> ou caso precise de ajuda <router-link :to="{ name: 'support'}">clique aqui.</router-link></p>
        </div>
    </div>
</template>

<script>
export default {
    metaInfo () {
        return {
            title: `CyberClass - Página não encontrada`
        }
    }
}
</script>

<style scoped lang="scss">
    .header {
        background: #000;

        h1 {
            color: #fff;
            font-weight: 700;
            font-size: 30px;
        }

        h2 {
            color: #fff;
            font-size: 20px;
            font-weight: 700;
            margin-bottom: 20px;
        }

        .animation-box {
            position: relative;
            display: inline-block;

            &:before {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                height: 10%;
                width:100%;
                background: #000;
            }
            
            img {
                width: auto;
                max-width: 100%;
            }
        }
    }

    .message {
        padding: 30px 15px;
        font-size: 18px;
    }
</style>